import { Fragment, useState, useCallback, useEffect, useRef, useLayoutEffect } from 'react';
import { Table, Tabs } from 'antd';
import { useNavigate } from 'react-router-dom';
import { fullPagerConfig } from '@/utils/property';
import { get } from '@/core/request';
import './CheckOrganizations.less';
import PageHeader from '@components/PageHeader/PageHeader';
import { useHorizontalScrollGuard } from '@/hooks/useHorizontalScrollGuard';
import { useTableScrollY, MAIN_TOOLBAR_DEDUCT_SELECTORS } from '@/hooks/useTableScrollY';
import { useVerticalScrollShadow } from '@/hooks/useVerticalScrollShadow';
import { useEnableTableScrollYLayout } from '@/layouts/tableScrollLayout';
import CheckOrganizationsFilterPanel from './CheckOrganizationsFilterPanel';

export default function CheckOrganizations() {
    // 渲染table数据的state
    const [tabledata, setTableData] = useState({});
    const [tabledataTwo, setTableDataTwo] = useState({});
    const [tabledataThree, setTableDataThree] = useState({});
    const [filterObj, setFilterObj] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [orgType, setOrgType] = useState('1');

    const navigate = useNavigate();

    // 分页设置
    const [pageSize, setPageSize] = useState(10);
    const [currPage, setCurrPage] = useState(1);
    const [pageSizeTwo, setPageSizeTwo] = useState(10);
    const [currPageTwo, setCurrPageTwo] = useState(1);
    const [pageSizeThree, setPageSizeThree] = useState(10);
    const [currPageThree, setCurrPageThree] = useState(1);
    // 改变一页有多少数据
    const changePageSize = useCallback(pageSize => {
        setPageSize(pageSize);
    }, []);
    const changePageSizeTwo = useCallback(pageSizeTwo => {
        setPageSizeTwo(pageSizeTwo);
    }, []);
    const changePageSizeThree = useCallback(pageSizeThree => {
        setPageSizeThree(pageSizeThree);
    }, []);
    // 改变第几页
    const changeCurrPage = useCallback(page => {
        setCurrPage(page);
    }, []);
    const changeCurrPageTwo = useCallback(page => {
        setCurrPageTwo(page);
    }, []);
    const changeCurrPageThree = useCallback(page => {
        setCurrPageThree(page);
    }, []);
    //分页数据
    const paginationProps = {
        ...fullPagerConfig,
        showSizeChanger: { placement: 'topRight' },
        pageSize,
        size: 'small',
        total: tabledata.totalCount,
        onShowSizeChange: (_current, pageSize) => changePageSize(pageSize),
        onChange: page => {
            changeCurrPage(page);
        },
        current: currPage,
    };
    //分页数据
    const paginationPropsTwo = {
        ...fullPagerConfig,
        showSizeChanger: { placement: 'topRight' },
        pageSize: pageSizeTwo,
        size: 'small',
        total: tabledataTwo.totalCount,
        onShowSizeChange: (_current, pageSize) => changePageSizeTwo(pageSize),
        onChange: page => {
            changeCurrPageTwo(page);
        },
        current: currPageTwo,
    };
    //分页数据
    const paginationPropsThree = {
        ...fullPagerConfig,
        showSizeChanger: { placement: 'topRight' },
        pageSize: pageSizeThree,
        size: 'small',
        total: tabledataThree.totalCount,
        onShowSizeChange: (_current, pageSize) => changePageSizeThree(pageSize),
        onChange: page => {
            changeCurrPageThree(page);
        },
        current: currPageThree,
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedRowKeys, _selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);
        },
    };

    const { code, name, belongsUnitName, type, createdStartAt, createdEndAt, adminName } = filterObj;

    const getData = useCallback(() => {
        let thisPages = '1';
        let thisPageSize = '10';
        if (orgType === '2') {
            thisPages = currPageTwo;
            thisPageSize = pageSizeTwo;
        } else if (orgType === '3') {
            thisPages = currPageThree;
            thisPageSize = pageSizeThree;
        } else if (orgType === '1') {
            thisPages = currPage;
            thisPageSize = pageSize;
        }

        get(`/healthclass/boss/organizations/list`, {
            page: thisPages,
            pageSize: thisPageSize,
            code,
            name,
            belongsUnitName,
            type,
            createdStartAt,
            createdEndAt,
            examineStatus: orgType,
            adminName,
        }).then(res => {
            if (res.status_code === 200) {
                if (orgType === '2') {
                    setTableDataTwo(res.data);
                } else if (orgType === '3') {
                    setTableDataThree(res.data);
                } else if (orgType === '1') {
                    setTableData(res.data);
                }
            }
        });
    }, [orgType, currPage, pageSize, currPageTwo, pageSizeTwo, currPageThree, pageSizeThree, code, name, belongsUnitName, type, createdStartAt, createdEndAt, adminName]);

    const checkOrg = useCallback(
        row => {
            return () => {
                navigate(`/healthclass/CheckOrganizationsInfo`, { state: row });
            };
        },
        [navigate],
    );

    const onChange = key => {
        setOrgType(String(key));
    };
    const handleFilterFinish = value => {
        setFilterObj(value);
        setCurrPage(1);
        setCurrPageTwo(1);
        setCurrPageThree(1);
    };

    const handleReset = () => {
        setFilterObj({});
        setCurrPage(1);
        setCurrPageTwo(1);
        setCurrPageThree(1);
    };

    // 渲染table数据
    useEffect(() => {
        getData();
    }, [getData]);

    // fixed-scroll 三件套：表格高度自适应 + 横向滚动守卫 + 纵向阴影
    const tableRegionRef = useRef(null);
    const tableScrollContainerRef = useRef(null);
    const [scrollContainerVersion, setScrollContainerVersion] = useState(0);
    const enableTableScrollYLayout = useEnableTableScrollYLayout();
    const tableScrollY = useTableScrollY(tableRegionRef, {
        enabled: enableTableScrollYLayout,
        heightRootClassName: 'main-container-card',
        scrollYOffset: 0,
        deductSiblingSelectors: MAIN_TOOLBAR_DEDUCT_SELECTORS,
    });

    useHorizontalScrollGuard(tableScrollContainerRef, { threshold: 6, edgeHoldMs: 220, watchValue: scrollContainerVersion });
    useVerticalScrollShadow(tableScrollContainerRef, { threshold: 2, watchValue: scrollContainerVersion });

    useLayoutEffect(() => {
        const region = tableRegionRef.current;
        if (!region) return;
        const resolveScrollContainer = () => {
            const next = region.querySelector('.ant-table-body') ?? region.querySelector('.ant-table-content');
            if (tableScrollContainerRef.current !== next) {
                tableScrollContainerRef.current = next;
                setScrollContainerVersion(v => v + 1);
            }
        };
        resolveScrollContainer();
        let rafId = 0;
        const mutationObserver = new MutationObserver(() => {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
                rafId = 0;
                resolveScrollContainer();
            });
        });
        mutationObserver.observe(region, { childList: true, subtree: true });
        return () => {
            if (rafId) cancelAnimationFrame(rafId);
            mutationObserver.disconnect();
        };
    }, []);

    const columns = [
        { title: '学苑ID', dataIndex: 'code' },
        { title: '学苑名称', dataIndex: 'name' },
        { title: '所属主体', dataIndex: 'belongsUnitName' },
        {
            title: '主体类型',
            dataIndex: 'belongsUnitType',
            render: (belongsUnitType, _row) => (
                <Fragment>
                    {belongsUnitType === 2 && <span> 机构</span>}
                    {belongsUnitType === 1 && <span> 个人</span>}
                </Fragment>
            ),
        },
        {
            title: '学苑类型',
            dataIndex: 'type',
            render: (type, _row) => (
                <Fragment>
                    {type === 1 && <span> 试用</span>}
                    {type === 2 && <span> 正式</span>}
                </Fragment>
            ),
        },
        {
            title: '开放类型',
            dataIndex: 'limitType',
            render: (limitType, _row) => (
                <Fragment>
                    {limitType === 1 && <span> 私享</span>}
                    {limitType === 2 && <span> 公开</span>}
                </Fragment>
            ),
        },
        { title: '管理员', dataIndex: 'adminName' },
        { title: '管理员手机号', dataIndex: 'phone' },
        { title: '申请时间', dataIndex: 'createdAt' },
        {
            title: '操作',
            dataIndex: 'examineStatus',
            render: (examineStatus, row) => (
                <Fragment>
                    {examineStatus === 1 && (
                        <span className="operate-style" onClick={checkOrg(row)}>
                            审核
                        </span>
                    )}
                    {examineStatus === 2 && (
                        <span className="operate-style" onClick={checkOrg(row)}>
                            详情
                        </span>
                    )}
                    {examineStatus === 3 && (
                        <span className="operate-style" onClick={checkOrg(row)}>
                            详情
                        </span>
                    )}
                </Fragment>
            ),
        },
    ];

    const renderTable = (dataSource, pagination, className) => (
        <Table
            className={tableScrollY != null ? `custom-table-scrollbar-always ${className}` : className}
            rowSelection={rowSelection}
            columns={columns}
            dataSource={dataSource}
            pagination={pagination}
            rowKey={row => row.id}
            bordered
            sticky
            size="medium"
            scroll={{ x: 'max-content', ...(tableScrollY != null ? { y: tableScrollY } : {}) }}
        />
    );

    const currentTableData = orgType === '2' ? tabledataTwo.list : orgType === '3' ? tabledataThree.list : tabledata.list;
    const currentPagination = orgType === '2' ? paginationPropsTwo : orgType === '3' ? paginationPropsThree : paginationProps;
    const currentTableClassName = orgType === '1' ? 'checkorg-table' : 'checkaorg-table';

    return (
        <div className="page-container list-page-container healthclass-check-page">
            <PageHeader title="学苑审核管理" breadcrumb={[{ label: '健学云' }, { label: '学苑管理' }, { label: '学苑审核管理' }]} />

            <CheckOrganizationsFilterPanel filter={filterObj} onFinish={handleFilterFinish} onReset={handleReset} />

            <div ref={tableRegionRef} className="table-region-container healthclass-check-table-region">
                <div className="main-toolbar healthclass-check-toolbar">
                    <Tabs
                        className="healthclass-check-tabs"
                        activeKey={orgType}
                        onChange={onChange}
                        items={[
                            { key: '1', label: '待审核', children: null },
                            { key: '2', label: '审核通过', children: null },
                            { key: '3', label: '审核驳回', children: null },
                        ]}
                    />
                </div>

                <div className="list-table-wrap healthclass-check-table-wrap">{renderTable(currentTableData, currentPagination, currentTableClassName)}</div>
            </div>
        </div>
    );
}
